
const LoaderforHomePage = () => {
  return (
    <div className="loader-wrapper">
      <div className="ring"></div>
      <p className="loader-text">Visit Dubai...</p>
    </div>
  );
};

export default LoaderforHomePage;